import React from "react";
import Navbar from "../components/layout/Navbar";
import PlatformPageHero from "../components/platform/PlatformPageHero";
import PrivacySection from "../components/sections/home/PrivacySection";

const PrivacyArchitecturePage = () => (
  <div className="min-h-screen bg-paper">
    <Navbar />
    <main className="pt-16">
      <PlatformPageHero
        eyebrow="Privacy architecture"
        title="Privacy controls inside the processing pipeline"
        body="TelcofyCore runs within the operator environment and applies the configured filters, aggregation rules and validation checks before data leaves that boundary."
      />
      <PrivacySection />
    </main>
  </div>
);

export default PrivacyArchitecturePage;
